import { toParams } from "../../utility/utility";
import PopupWindow from "../login/popupWindow";

class SlackPopupWindow extends PopupWindow {

    constructor(id, url, options = {}) {
        super(id, url, options);
    }

    poll = () => {
        this.promise = new Promise((resolve, reject) => {
            this._iid = window.setInterval(() => {
                try {
                    const popup = this.window;
                    if(!popup || popup.closed !== false) {
                        let data = {
                            "ok": false,
                            "code": "popup_closed"
                        };
                        reject(data);
                        this.close();
                        return;
                    } else if((!popup.location.href.includes("localhost:3000") && !popup.location.href.includes("idrivecompute.com")) || popup.location.pathname === "blank") {
                        return;
                    } else {
                        let data = toParams(popup.location.search.replace(/^\?/, ''));
                        if(popup.location.href.includes("/app/error")) {
                            data.ok = false;
                            reject(data);
                        }
                        else {
                            data.ok = true;
                            resolve(data);
                        }
                        this.close();
                    }
                } catch(err) {
                    /*
                    * Ignore DOMException: Blocked a frame with origin from accessing a
                    * cross-origin frame.
                    */
                }
            }, 500);
        });
    };

    static open(...args) {
        const popup = new this(...args);

        popup.open();
        popup.poll();

        return popup;
    }
}

export default SlackPopupWindow;